import React, { useEffect, useState } from "react";
import Masonry from "react-masonry-css";
import "../../assets/css/masonry.css";
import NoOrder from "../Kitchen/Components/NoOrder";
import ApiConnect from "../../Utils/ApiConnect";
import notificationSound from "../../assets/sound/Notification.mp3";
import OrderSlip from "./OrderSlip";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchDisplayData,
  recieveMsg,
} from "../../redux/actions/Socket.Action";
import { useRouteMatch } from "react-router-dom";
import useWebSocket from "../../sockets/WsHooks";
function OrderDetails(props) {
  const dispatch = useDispatch();
  const [sendMessage] = useWebSocket();
  const { url } = useRouteMatch();
  const display = props.display.toLowerCase() || "";
  const displayData = useSelector((state) => state.Socket[display]);
  const socketStatus = useSelector((state) => state.Socket.status);
  const [audio] = useState(
    typeof Audio !== "undefined" && new Audio(notificationSound)
  );
  const [tempData, setTempdata] = useState(displayData);
  useEffect(() => {
    dispatch(fetchDisplayData(display));
    sendMessage("kitchen");
    if (!socketStatus) {
      FetchOrderData();
      const interval = setInterval(() => {
        FetchOrderData();
      }, 5000);
      return () => clearInterval(interval);
    }
  }, []);

  useEffect(() => {
    const lastorderList = sessionStorage.getItem(display + "order");
    setTempdata(displayData);
    if (lastorderList && displayData.length > lastorderList) {
      if (url.toUpperCase() === "/" + display.toUpperCase()) {
        audio.play();
      }
    }
    sessionStorage.setItem(display + "order", displayData.length);
  }, [displayData]);

  const FetchOrderData = () => {
    ApiConnect.get(`/POS/Orders/Details?location=${display}`)
      .then((response) => {
        const message = { type: display, data: response.data };
        dispatch(recieveMsg(message));
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const breakPoints = {
    default: 4,
    1112: 3,
    1100: 3,
    700: 1,
  };
  return (
    <div className="card-body">
      {tempData && tempData.length > 0 ? (
        <Masonry
          breakpointCols={breakPoints}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {tempData.map((order, index) => (
            <OrderSlip Orders={order} key={index} place={display} />
          ))}
        </Masonry>
      ) : (
        <NoOrder />
      )}
    </div>
  );
}
export default React.memo(OrderDetails);
